(function(window, document) {
    // Create a global "_" object if it doesn't exist
    window._ = window._ || {};
  
    /* ================================
       add-class.js
    ================================ */
    _.addClass = function(el, className) {
      if (!_.hasClass(el, className)) {
        if (el.classList) {
          el.classList.add(className);
        } else {
          el.className += ' ' + className;
        }
      }
    };
  
    /* ================================
       ajax.js
    ================================ */
    _.ajax = function(opts, args) {
      const config = {
        cache: false,
        contentType: null,
        data: '',
        dataObject: {},
        headers: {},
        type: null,
        url: null,
        withCredentials: false,
        success: function(resp){ console.warn(resp); },
        error: function(resp) { console.warn(resp); }
      };
      const passedData = (typeof args === 'undefined') ? null : args;
      let url;
      let c;
      let xhr;
      let timestamp = '?ts=';
  
      function init() {
        c = _.extend(config, opts);
        if (c.url.indexOf('?') > -1) { timestamp = '&ts='; }
        url = c.cache ? c.url : c.url + timestamp + Date.now().toString();
  
        xhr = new XMLHttpRequest();
        xhr.open(c.type, url, true);
        setHeaders(xhr);
        xhr.onload = onLoadHandler;
        xhr.onerror = errorHandler;
        xhr.withCredentials = c.withCredentials;
  
        if (c.data) {
          xhr.send(_.objectToQueryString(c.data));
        } else {
          if (c.dataObject) {
            xhr.send(c.dataObject);
          } else {
            console.warn('data is not defined.');
          }
        }
      }
      function setHeaders(xhr) {
        let defaultContentType = 'application/x-www-form-urlencoded; charset=UTF-8',
            contentType = c.contentType ? c.contentType : defaultContentType,
            headers = c.headers;
        if (!_.isObjectEmpty(headers)) {
          if (!hasContentType(headers)) {
            headers['Content-Type'] = defaultContentType;
          }
          Object.keys(headers).forEach(function(name) {
            xhr.setRequestHeader(name, headers[name]);
          });
        } else {
          xhr.setRequestHeader('Content-Type', contentType);
        }
      }
      function hasContentType(headers) {
        return Object.keys(headers).some(function(name) {
          return name.toLowerCase() === 'content-type';
        });
      }
      function onLoadHandler() {
        let resp = xhr.responseText;
        if (typeof resp !== 'object') {
          try { resp = JSON.parse(resp); } catch(e) { }
        }
        if (xhr.status >= 200 && xhr.status < 400) {
          if (resp.status) {
            if ((resp.status >= 200 && resp.status < 400) || resp.status === 'success' || resp.status === 'available') {
              c.success(resp, args);
            } else {
              c.error(resp, args);
            }
          } else {
            c.success(resp, args);
          }
        } else {
          c.error(resp);
        }
      }
      function errorHandler() {
        c.error(xhr.responseText);
      }
      return init();
    };
  
    /* ================================
       array-reduce.js
    ================================ */
    _.reduceArray = function(r) {
      let n = [];
      if (Array.isArray(r)) {
        for (let i = 0; i < r.length; i++) {
          if (n.indexOf(r[i]) === -1) {
            n.push(r[i]);
          }
        }
      } else {
        console.warn('argument not an array.', r);
        return false;
      }
      return n;
    };
  
    /* ================================
       array-to-lower.js
    ================================ */
    _.arrayToLower = function(r) {
      if (Array.isArray(r)) {
        for (let i = 0; i < r.length; i++) {
          r[i] = r[i].toLowerCase();
        }
      } else {
        console.warn('argument not an array.', r);
        return false;
      }
      return r;
    };
  
    /* ================================
       click-outside.js
    ================================ */
    _.clickOutside = function(opts) {
      let config = {
        callback: null,
        condition: null,
        exclude_selectors: '',
        selector: ''
      };
      let c = _.extend(config, opts);
      let excludedElements = [];
  
      function init() { addEvents(); }
      function setupExcluded() {
        excludedElements = [];
        let excludedSelectors = [];
        if (!c.exclude_selectors) return;
        if (c.exclude_selectors.indexOf(',') !== -1) {
          excludedSelectors = c.exclude_selectors.split(',');
        } else {
          excludedSelectors.push(c.exclude_selectors);
        }
        excludedSelectors.forEach(addElementToExcludedArray);
      }
      function addElementToExcludedArray(selector) {
        let els = document.querySelectorAll(selector);
        if (els) {
          for (let i = 0; i < els.length; i++) {
            excludedElements.push(els[i]);
            if (els[i].children) {
              for (let j = 0; j < els[i].children.length; j++) {
                excludedElements.push(els[i].children[j]);
              }
            }
          }
        }
      }
      function isExcludedElement(el) {
        return excludedElements.indexOf(el) !== -1;
      }
      function addEvents() {
        _.addEvent({ id: document, event: 'click', fn: onDocumentClick });
      }
      function onDocumentClick(e) {
        setupExcluded();
        let isExElement = excludedElements.some(function(exEl) {
          return exEl === e.target;
        });
        let isConditionFn = typeof c.condition === 'function';
        let hasMetConditions = isExElement ? (isConditionFn && !isExElement) : (isConditionFn && c.condition());
        if (!hasMetConditions) return;
        let hasClickedOutside = !_.parents(e.target, c.selector);
        if (typeof c.callback === 'function' && hasClickedOutside) c.callback();
      }
      return { init: init() };
    };
  
    /* ================================
       debounce.js
    ================================ */
    _.debounce = function(func, threshold, execAsap) {
      let timeout;
      return function debounced() {
        let obj = this, args = arguments;
        function delayed() {
          if (!execAsap)
            func.apply(obj, args);
          timeout = null;
        }
        if (timeout) clearTimeout(timeout);
        else if (execAsap) func.apply(obj, args);
        timeout = setTimeout(delayed, threshold || 100);
      };
    };
  
    /* ================================
       encode.js
    ================================ */
    _.encode = function(value) {
      return encodeURIComponent(value);
    };
  
    /* ================================
       events.js and addEvent / removeEvent wrappers
    ================================ */
    _.domEvent = function(opts, applyE) {
      let c = opts,
          eApply = (applyE !== undefined) ? applyE : true,
          $id, $class, isString, hasIds, hasEvents, $trigger, i, idArr, eventArr;
      function init() {
        if (c.id) {
          if (c.fn || c.event) {
            checkForArray();
            if (hasIds) {
              idArr = c.id.split(',');
              for (i = 0; i < idArr.length; i++) {
                c.id = idArr[i];
                bindEvents();
              }
            } else {
              bindEvents();
            }
          } else {
            if (c.fn === null) { console.warn('No function defined.'); }
            if (c.event === null) { console.warn('No event defined.'); }
          }
        } else {
          console.warn('No ID defined.');
        }
      }
      function checkForArray() {
        isString = (typeof c.id === 'string');
        if (isString) { hasIds = _.isDelimitedArray(c.id); }
        hasEvents = _.isDelimitedArray(c.event);
      }
      function bindEvents() {
        maplets();
        if (c.className) { bindLoop(); } else { bindSingle(); }
      }
      function maplets() {
        if (isString) { $id = document.getElementById(c.id); }
        else { $id = c.id; }
        if ($id) {
          $class = c.className ? $id.querySelectorAll('.' + c.className) : null;
        } else {
          console.warn('Could not find id ' + (isString ? c.id : 'element'));
        }
      }
      function bindLoop() {
        if ($class) {
          for (i = 0; i < $class.length; i++) {
            $trigger = $class[i];
            if ($trigger) {
              if (eApply) {
                if (hasEvents) {
                  eventArr = c.event.split(',');
                  for (i = 0; i < eventArr.length; i++) {
                    $trigger.addEventListener(eventArr[i], c.fn, null);
                  }
                } else {
                  $trigger.addEventListener(c.event, c.fn, null);
                }
              } else {
                $trigger.removeEventListener(c.event, c.fn, null);
              }
            }
          }
        }
      }
      function bindSingle() {
        if ($id) {
          if (eApply) {
            if (hasEvents) {
              eventArr = c.event.split(',');
              for (i = 0; i < eventArr.length; i++) {
                $id.addEventListener(eventArr[i], c.fn, false);
              }
            } else {
              $id.addEventListener(c.event, c.fn, false);
            }
          } else {
            $id.removeEventListener(c.event, c.fn, false);
          }
        }
      }
      return init();
    };
    _.addEvent = function(opts) {
      if (opts === undefined) { console.warn('_.addEvent requires a config object.'); }
      else { _.domEvent(opts, true); }
    };
    _.removeEvent = function(opts) {
      if (opts === undefined) { console.warn('_.removeEvent requires a config object.'); }
      else { _.domEvent(opts, false); }
    };
  
    /* ================================
       extend.js
    ================================ */
    _.extend = function(config, obj) {
      obj = obj || {};
      Object.keys(config).forEach(function(key) {
        if (obj[key] === undefined) {
          obj[key] = config[key];
        } else {
          if (obj[key] && _.isObject(obj[key]) && _.isObject(config[key])) {
            Object.keys(config[key]).forEach(function(childKey) {
              if (obj[key][childKey] === undefined) {
                obj[key][childKey] = config[key][childKey];
              }
            });
          }
        }
      });
      return obj;
    };
  
    /* ================================
       focus-first-input.js
    ================================ */
    _.focusFirst = function(id, sel) {
      let $container = document.getElementById(id),
          inputSelector = sel ? sel : 'input',
          $inputs, $input, type, count, i;
      if ($container) {
        $inputs = $container.querySelectorAll(inputSelector);
        count = $inputs.length;
        if (count > 0) {
          for (i = 0; i < count; i++) {
            $input = $inputs[i];
            type = $input.getAttribute('type');
            if (type !== 'hidden') {
              $input.focus();
              break;
            }
          }
        }
      } else {
        console.warn("id doesn't exist");
      }
    };
  
    /* ================================
       format-money.js
    ================================ */
    function formatMoney(cents, format, currency) {
      if (typeof cents == 'string') { cents = cents.replace('.', ''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) { return 0; }
        number = (number/100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      }
      switch (format) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_with_currency':
          value = currency + formatWithDelimiters(cents, 2);
          break;
        case 'amount_with_currency_without_trailing_zeros':
          value = currency + formatWithDelimiters(cents, 2);
          if (value.indexOf('.00') !== -1) { value = value.replace('.00', ''); }
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
      return value;
    }
    _.formatMoney = formatMoney;
  
    /* ================================
       format-price-display.js
    ================================ */
    _.formatPriceDisplay = function(price) {
      const moneyFormat = SDG && SDG.Data && SDG.Data.moneyFormat ? SDG.Data.moneyFormat : "${{amount}}";
      const moneyCurrencyFormat = SDG && SDG.Data && SDG.Data.moneyCurrencyFormat ? SDG.Data.moneyCurrencyFormat : "${{amount}}";
      const formatPrice = _.formatPrice(price);
      const amount = _.numberWithCommas(formatPrice);
      let money = moneyFormat.includes('$') && !moneyCurrencyFormat.includes('USD') ? moneyCurrencyFormat : moneyFormat;
      return money.replace('{{amount}}', amount)
                  .replace('{{amount_no_decimals}}', amount)
                  .replace('{{amount_with_comma_separator}}', amount)
                  .replace('{{amount_no_decimals_with_comma_separator}}', amount)
                  .replace('{{amount_with_apostrophe_separator}}', amount);
    };
  
    /* ================================
       format-price-number.js
    ================================ */
    _.formatPriceNumber = function(price) {
      return parseFloat((price / 100).toFixed(2));
    };
  
    /* ================================
       format-price.js
    ================================ */
    _.formatPrice = function(price) {
      return (price / 100).toFixed(2);
    };
  
    /* ================================
       get-hidden-styles.js
    ================================ */
    _.getHiddenStyles = function(el) {
      let clone = el.cloneNode(true);
      let parent = el.parentNode;
      let posVal = window.getComputedStyle(parent).position;
      let body = document.body;
      let docEl = document.documentElement;
      let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      let clientTop = docEl.clientTop || body.clientTop || 0;
      clone.setAttribute('data-clone', 'true');
      clone.removeAttribute('style');
      parent.appendChild(clone);
      clone.style.height = 'auto';
      clone.style.display = 'block';
      clone.style.visibility = 'hidden';
      clone.style.position = 'absolute';
      let cloneHeight = clone.offsetHeight;
      let clonePaddingTop = window.getComputedStyle(clone).paddingTop;
      let clonePaddingBottom = window.getComputedStyle(clone).paddingBottom;
      let cloneRect = clone.getBoundingClientRect();
      let cloneOffsetTop = Math.round(cloneRect.top + scrollTop - clientTop);
      clone.remove();
      if (posVal === 'static') { parent.style.position = ''; }
      return {
        elHeight: cloneHeight,
        elOffsetTop: cloneOffsetTop,
        elPaddingTop: clonePaddingTop,
        elPaddingBottom: clonePaddingBottom
      };
    };
  
    /* ================================
       get-query-string.js
    ================================ */
    _.getQueryString = function(object) {
      return Object.keys(object).reduce(function(acc, item) {
        var prefix = acc ? acc + '&' : '';
        return prefix + _.encode(item) + '=' + _.encode(object[item]);
      }, '');
    };
  
    /* ================================
       get-sized-image-url.js
    ================================ */
    _.getSizedImageUrl = function(imgUrl, size) {
      if (!imgUrl) return '//cdn.searchspring.net/ajax_search/img/missing-image-75x75.gif';
      if (!size) return imgUrl;
      if (size === 'master') return _.removeProtocol(imgUrl);
      var match = imgUrl.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (match !== null) {
        var parts = imgUrl.split(match[0]);
        return _.removeProtocol(parts[0] + '_' + size + match[0]);
      }
    };
  
    /* ================================
       get-url-parameter.js
    ================================ */
    _.getUrlParameter = function(sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1));
      var sURLVariables = sPageURL.split('&');
      for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    };
  
    /* ================================
       handlesize.js
    ================================ */
    _.handleize = function(str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
    };
  
    /* ================================
       has-class.js
    ================================ */
    _.hasClass = function(el, className) {
      if (el.classList) {
        return el.classList.contains(className);
      } else {
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
      }
    };
  
    /* ================================
       hide.js
    ================================ */
    _.hide = function(obj) {
      if (obj && obj.style.display !== 'none') {
        obj.style.display = 'none';
      }
    };
  
    /* ================================
       index.js
    ================================ */
    _.index = function(node) {
      var children = node.parentNode.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i] === node) return i;
      }
    };
  
    /* ================================
       insert-after.js
    ================================ */
    _.insertAfter = function(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };
  
    /* ================================
       is-delimited-array.js
    ================================ */
    _.isDelimitedArray = function(str, delimiter) {
      if (!str) {
        console.warn('No string defined');
        return false;
      }
      delimiter = delimiter || ',';
      return str.indexOf(delimiter) !== -1;
    };
  
    /* ================================
       is-dom-element.js
    ================================ */
    _.isDomElement = function(el) {
      return el instanceof Element;
    };
  
    /* ================================
       is-object-empty.js
    ================================ */
    _.isObjectEmpty = function(obj) {
      return _.isObject(obj) && Object.keys(obj).length === 0;
    };
  
    /* ================================
       is-object.js
    ================================ */
    _.isObject = function(data) {
      return Object.prototype.toString.call(data) === '[object Object]';
    };
  
    /* ================================
       is-visible.js
    ================================ */
    _.isVisible = function(el) {
      return el.offsetParent !== null;
    };
  
    /* ================================
       load-jsonp.js
    ================================ */
    _.loadJSONP = (function(window, document, undefined) {
      let uuid = 0,
          head = document.head || document.getElementsByTagName('head')[0],
          main_script = document.createElement('script');
      main_script.type = 'text/javascript';
      return function(url, callback, context) {
        let name = '__jsonp_' + uuid++;
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'callback=' + name;
        let script = main_script.cloneNode();
        script.src = url;
        window[name] = function(data) {
          callback.call(context || window, data);
          head.removeChild(script);
          script = null;
          delete window[name];
        };
        head.appendChild(script);
      };
    })(window, document);
  
    /* ================================
       load-script.js
    ================================ */
    function loadScript(src, done) {
      const js = document.createElement('script');
      js.src = src;
      js.onload = function() { done(); };
      js.onerror = function() { console.error("Failed to load script " + src); done(); };
      document.head.appendChild(js);
    }
    _.loadScript = loadScript;
  
    /* ================================
       media-query.js
    ================================ */
    _.mq = function(opts) {
      let config = {
        callback: null,
        view: null,
        views: {
          smallest_phone: '(max-width: 374px)',
          small_phone: '(max-width: 640px)',
          phone: '(max-width: 767px)',
          mobile: '(max-width: 1024px)',
          phone_to_desktop: '(min-width: 563px)',
          tablet: '(min-width: 768px)',
          tablet_only: '(min-width: 768px) and (max-width: 1024px)',
          tablet_portrait: '(min-width: 768px) and (max-width: 979px)',
          tablet_landscape: '(min-width: 980px) and (max-width: 1024px)',
          desktop: '(min-width: 1025px)',
          desktop_to_large: '(min-width: 1025px) and (max-width: 1280px)',
          desktop_large: '(min-width: 1281px)',
          desktop_large_to_huge: '(min-width: 1281px) and (max-width: 1400px)',
          desktop_huge: '(min-width: 1401px)'
        }
      };
      let c = _.extend(config, opts);
      let currentView = null;
      if (c.view) {
        Object.keys(c.views).forEach(function(key) {
          if (key === c.view) { currentView = c.views[key]; }
        });
        let query = window.matchMedia(currentView);
        if (query.matches === true && typeof c.callback === 'function') {
          c.callback();
        }
      }
    };
  
    /* ================================
       namespace.js
    ================================ */
    _.namespace = function(obj, name) {
      obj = obj || {};
      obj = JSON.parse(JSON.stringify(obj));
      let objNode, namedlet;
      if (obj && _.isObject(obj)) {
        Object.keys(obj).forEach(function(key) {
          if (obj[key]) {
            if (typeof obj[key] !== 'object') {
              objNode = obj[key].toString();
              namedlet = name + objNode.charAt(0).toUpperCase() + objNode.slice(1);
              obj[key] = namedlet;
            } else if (Array.isArray(obj[key])) {
              obj[key].forEach(function(id, idx, arr) {
                objNode = name + id.charAt(0).toUpperCase() + id.slice(1);
                arr[idx] = objNode;
              });
            }
          }
        });
      } else {
        console.warn('obj is not defined, or is not an object');
      }
      return obj;
    };
  
    /* ================================
       number-with-commas.js
    ================================ */
    _.numberWithCommas = function(x) {
      const separator = SDG && SDG.Data && SDG.Data.moneyThousandsSeparator ? SDG.Data.moneyThousandsSeparator : ',';
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };
  
    /* ================================
       object-to-query-string.js
    ================================ */
    _.objectToQueryString = function(data) {
      return _.isObject(data) ? _.getQueryString(data) : data;
    };
  
    /* ================================
       parents.js
    ================================ */
    _.parents = function(elem, selector) {
      let parents = [];
      let firstChar;
      if (selector) { firstChar = selector.charAt(0); }
      for (; elem && elem !== document; elem = elem.parentNode) {
        if (selector) {
          if (firstChar === '.') {
            if (elem.classList.contains(selector.substr(1))) {
              parents.push(elem);
            }
          }
          if (firstChar === '#') {
            if (elem.id === selector.substr(1)) {
              parents.push(elem);
            }
          }
          if (firstChar === '[') {
            if (elem.hasAttribute(selector.substr(1, selector.length - 1))) {
              parents.push(elem);
            }
          }
          if (elem.tagName.toLowerCase() === selector) {
            parents.push(elem);
          }
        } else {
          parents.push(elem);
        }
      }
      return parents.length === 0 ? null : parents;
    };
  
    /* ================================
       ready.js
    ================================ */
    _.ready = function(fn) {
      if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'){
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    };
  
    /* ================================
       remap-size-values.js
    ================================ */
    _.remapSizeValues = function(val) {
      let label;
      if (val) { val = val.toLowerCase(); }
      switch(val) {
        case 'xs': label = 'extra small'; break;
        case 's': label = 'small'; break;
        case 'm': label = 'medium'; break;
        case 'l': label = 'large'; break;
        case 'xl': label = 'extra large'; break;
        case 'xxl':
        case '2xl': label = '2x Large'; break;
        case 'xxxl':
        case '3xl': label = '3x Large'; break;
        default: label = val; break;
      }
      return label;
    };
  
    /* ================================
       remove-class-by-prefix.js
    ================================ */
    _.removeClassByPrefix = function(el, prefix) {
      const regx = new RegExp('\\b' + prefix + '.*?\\b', 'g');
      el.className = el.className.replace(regx, '');
      return el;
    };
  
    /* ================================
       remove-class.js
    ================================ */
    _.removeClass = function(el, className) {
      if (_.hasClass(el, className)) {
        if (el.classList) {
          el.classList.remove(className);
        } else {
          el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
      }
    };
  
    /* ================================
       remove-protocol.js
    ================================ */
    _.removeProtocol = function(url) {
      return url.replace(/http(s)?:/, '');
    };
  
    /* ================================
       replace.js
    ================================ */
    _.replace = function(string, needle, newValue) {
      let newString;
      if (string.indexOf(needle) !== -1) {
        newString = string.replace(needle, newValue);
      } else {
        newString = string;
      }
      return newString;
    };
  
    /* ================================
       scroll-to.js
    ================================ */
    _.scrollTo = function(opts) {
      let config = {
        callback: null,
        className: null,
        exec_now: false,
        id: null,
        offset: 0,
        target: null,
        timer: 500
      };
      let c = _.extend(config, opts);
      function init() {
        if (c.exec_now) {
          scroll();
        } else {
          if (c.id) { addEvents(); }
          else { console.warn('no id defined'); }
        }
      }
      function addEvents() {
        _.addEvent({ id: c.id, className: c.className, event: 'click', fn: scroll });
      }
      function scroll(e) {
        let start = window.pageYOffset,
            target = c.target ? c.target : this.getAttribute('href').replace('#',''),
            offsetVal,
            distance,
            duration,
            timeStart,
            timeElapsed;
        target = typeof target === 'string' ? document.getElementById(target) : target;
        if (target) {
          if (e) e.preventDefault();
        } else { return false; }
        offsetVal = (typeof c.offset === 'function') ? c.offset() : c.offset;
        distance = offsetVal + target.getBoundingClientRect().top;
        duration = (typeof c.timer === 'function') ? c.timer(distance) : c.timer;
        requestAnimationFrame(function(time) { timeStart = time; loop(time); });
        function loop(time) {
          timeElapsed = time - timeStart;
          window.scrollTo(0, easeInOutQuad(timeElapsed, start, distance, duration));
          if (timeElapsed < duration) { requestAnimationFrame(loop); }
          else { end(); }
        }
        function end() {
          window.scrollTo(0, start + distance);
          if (typeof c.callback === 'function') { c.callback(); }
        }
      }
      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      }
      return init();
    };
  
    /* ================================
       serialize.js
    ================================ */
    _.serialize = function(form, type = false) {
      if (!form || form.nodeName !== 'FORM') { return; }
      const isDataObject = type;
      const q = [];
      const o = {};
      let i, j;
      for (i = form.elements.length - 1; i >= 0; i--) {
        if (form.elements[i].name === '') { continue; }
        switch (form.elements[i].nodeName) {
          case 'INPUT':
            switch (form.elements[i].type) {
              case 'text':
              case 'hidden':
              case 'password':
              case 'button':
              case 'reset':
              case 'submit':
              case 'color':
              case 'date':
              case 'datetime-local':
              case 'email':
              case 'month':
              case 'number':
              case 'range':
              case 'search':
              case 'tel':
              case 'time':
              case 'url':
              case 'week':
                q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
                o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
                break;
              case 'checkbox':
              case 'radio':
                if (form.elements[i].checked) {
                  q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
                  o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
                }
                break;
              case 'file':
                break;
            }
            break;
          case 'TEXTAREA':
            q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
            o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
            break;
          case 'SELECT':
            switch (form.elements[i].type) {
              case 'select-one':
                q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
                o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
                break;
              case 'select-multiple':
                for (j = form.elements[i].options.length - 1; j >= 0; j--) {
                  if (form.elements[i].options[j].selected) {
                    q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].options[j].value));
                    o[form.elements[i].name] = encodeURIComponent(form.elements[i].options[j].value);
                  }
                }
                break;
            }
            break;
          case 'BUTTON':
            switch (form.elements[i].type) {
              case 'reset':
              case 'submit':
              case 'button':
                q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
                o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
                break;
            }
            break;
        }
      }
      return isDataObject ? o : q.join('&');
    };
  
    /* ================================
       show.js
    ================================ */
    _.show = function(obj) {
      if (obj && obj.style.display === 'none') {
        obj.style.display = 'block';
      }
    };
  
    /* ================================
       slide.js
    ================================ */
    _.slideUp = function(el) {
      if (!el) return;
      el.style.height = el.offsetHeight + 'px';
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    };
    _.slideDown = function(el) {
      if (!el) return;
      const hidden = _.getHiddenStyles(el);
      el.style.display = 'block';
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
      el.style.height = 0;
      setTimeout(function() {
        el.style.height = hidden.elHeight + 'px';
        el.style.paddingTop = hidden.elPaddingTop;
        el.style.paddingBottom = hidden.elPaddingBottom;
      }, 1);
    };
  
    /* ================================
       to-number.js
    ================================ */
    _.toNumber = function(n) {
      if (typeof n === 'string') n = parseInt(n);
      return n;
    };
  
    /* ================================
       transition.js
    ================================ */
    _.transition = function(opts) {
      opts.before = opts.before || null;
      opts.after = opts.after || null;
      opts.time = opts.time || 400;
      if (typeof opts.before === 'function') { opts.before(); }
      if (typeof opts.after === 'function') {
        setTimeout(opts.after, opts.time);
      }
    };
  
    /* ================================
       trigger.js
    ================================ */
    _.trigger = function(el, eventName, obj = null, bubbles = true, cancelable = true) {
      if (!el || !eventName) return false;
      var event = new CustomEvent(eventName, {
        detail: { el: el, time: new Date(), obj: obj },
        bubbles: bubbles,
        cancelable: cancelable
      });
      el.dispatchEvent(event);
    };
  
    /* ================================
       upcase.js
    ================================ */
    _.upcase = function(str) {
      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };
  
    /* ================================
       waypoint.js
    ================================ */
    _.waypoint = function(opts) {
      let config = {
        el: null,
        in: null,
        out: null,
        offset: null
      };
      let c = _.extend(config, opts);
      function init() {
        addEvents();
        checkWindowPosition();
      }
      function addEvents() {
        window.addEventListener('scroll', checkWindowPosition, false);
        _.windowResize(checkWindowPosition, 400);
      }
      function checkWindowPosition() {
        let windowPos = window.pageYOffset || document.documentElement.scrollTop,
            elOffset = c.el.offsetTop,
            offset = c.offset || 0,
            isPastEl = windowPos > (elOffset - offset);
        if (isPastEl) { if (typeof c.in === 'function') c.in(); }
        else { if (typeof c.out === 'function') c.out(); }
      }
      return init();
    };
  
    /* ================================
       window-resize.js
    ================================ */
    _.windowResize = function(fn, threshold, execAsap) {
      threshold = threshold || 100;
      execAsap = execAsap || false;
      if (fn) {
        window.addEventListener('resize', _.debounce(fn, threshold, execAsap));
      } else {
        console.warn('No function defined.');
      }
    };
  
})(window, document);
